import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import clsx from 'clsx';
import { useRef, useEffect } from 'react';
import { CloseIcon } from '../../icons/CloseIcon.js';
import { DangerIcon } from '../../icons/DangerIcon.js';
import { ExclamationMarkIcon } from '../../icons/ExclamationMarkIcon.js';
import { QuestionMarkEmptyIcon } from '../../icons/QuestionMarkEmptyIcon.js';
import { WarningIcon } from '../../icons/WarningIcon.js';
import { IconButton } from '../iconButton/IconButton.js';
import styles from './Alert.module.scss.js';

var icons = {
    error: jsx(DangerIcon, {}),
    tip: jsx(ExclamationMarkIcon, {}),
    warning: jsx(WarningIcon, {}),
    info: jsx(QuestionMarkEmptyIcon, {}),
};
var Alert = function (_a) {
    var _b;
    var title = _a.title, variant = _a.variant, desc = _a.desc, scrollToOnMount = _a.scrollToOnMount, hideIcon = _a.hideIcon, children = _a.children, className = _a.className, style = _a.style, tabIndex = _a.tabIndex, onClose = _a.onClose;
    var alertRef = useRef(null);
    useEffect(function () {
        if (scrollToOnMount && alertRef.current && alertRef.current.scrollIntoView) {
            alertRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        }
    }, [scrollToOnMount]);
    return (jsxs("div", __assign({ role: "alert", className: clsx(styles.alert, styles[variant], className), style: style, ref: alertRef, tabIndex: tabIndex }, { children: [!hideIcon && (jsx("div", __assign({ className: clsx(styles.iconWrapper, (_b = {},
                    _b[styles.iconWrapperWithDesc] = !!desc,
                    _b)) }, { children: icons[variant] }))), onClose && (jsx(IconButton, __assign({ "aria-label": "close", className: styles.closeButton, onClick: onClose, size: "xxs", variant: "inverted", color: "dark" }, { children: jsx(CloseIcon, { variant: "small" }) }))), jsxs("div", __assign({ className: styles.content }, { children: [jsxs("div", __assign({ className: styles.descWrapper }, { children: [jsx("p", __assign({ className: styles.title }, { children: title })), desc && jsx("p", __assign({ className: styles.desc }, { children: desc }))] })), children && jsx("div", __assign({ className: styles.children }, { children: children }))] }))] })));
};

export { Alert };
